
import { createSlice } from "@reduxjs/toolkit";

export const inspectUserSlice = createSlice({
    name: 'inspectUserStore',
    initialState: {
        value: {
            user: null,
            list: []
        }
    },
    reducers: {
        setInspectUserStore: (state, action) => {
            state.value.user = action.payload
        },
        setInspectUserListStore: (state, action) => {
            state.value.list = action.payload
        }
    }
})

export const { setInspectUserStore, setInspectUserListStore } = inspectUserSlice.actions

export default inspectUserSlice.reducer